module.exports = __webpack_public_path__ + "static/media/red-t.7bb7aa98.svg";